import { allApis as allGeneratedApi } from './allApis';

export const allApis = allGeneratedApi.enhanceEndpoints({});
